import styled from 'styled-components';

export const Container = styled.div`
   margin: 20px 0;
`;
export const Label = styled.div`
   font-size: 1rem;
   line-height: 1.2rem;
   color: #6a7d8b;
`;
export const Value = styled.div`
   font-size: 2.5rem;
   font-weight: bold;
   color: #101c40;
`;
